import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders,HttpErrorResponse  } from "@angular/common/http";

import {ServiceFileModel} from '../../models/servicefile'
import serviceConfig from '../service-config';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app/core/reducers';
import { selectAuthState } from '../../../app/core/auth/_selectors/auth.selectors';

@Injectable({
  providedIn: 'root'
})
export class ServicefileService {

  uri = serviceConfig.baseUrl + serviceConfig.endPoints.serviceFiles;
  headers = new HttpHeaders()
  altHeaders: HttpHeaders;

  constructor(private http:HttpClient, private store: Store<AppState>) {
    this.store.select(selectAuthState).subscribe((result) => { 
      this.headers = new HttpHeaders().set('Authorization', "Bearer "+result.authToken);
      this.altHeaders =new HttpHeaders()
                      .append('Authorization', "Bearer "+result.authToken)  
                      .append('accept','*/*')
                      .append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE, OPTIONS')
                      .append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept, Referer, User-Agent')
                      .append('accept','text/plain');
    })
  }


  addServiceFile(serviceFile: ServiceFileModel[]){
    this.http.post(`${this.uri}`, serviceFile, { headers: this.altHeaders }).subscribe(res => console.log('Done'));;
  }

  deleteServiceFile(fileId: number[]){
    this.http.delete(`${this.uri}/${fileId}`, { headers: this.altHeaders }).subscribe(res => console.log('Done'));;
  }

  getServiceFiles(serviceType:string,serviceNumber:number):Observable<any> {
    return this
      .http
      .get<any>(`${this.uri}?serviceType=${serviceType}&serviceId=${serviceNumber}`,
       { headers: this.altHeaders });

  }

}
